<script setup>
// advup — fatia 0A (R1, D5): liberar a pessoa do atendimento humano por segurança.
// Só administrador (o servidor confere), sempre com motivo: a liberação volta a
// deixar a IA e as automações falarem com quem estava em crise.
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  conversationId: { type: Number, required: true },
  contactId: { type: Number, required: true },
});

const { t } = useI18n();
const store = useStore();
const dialogRef = ref(null);
const motivo = ref('');
const enviando = ref(false);

const podeConfirmar = computed(() => motivo.value.trim().length > 0);

const open = () => {
  motivo.value = '';
  dialogRef.value?.open();
};

const confirmar = async () => {
  if (!podeConfirmar.value) return;
  enviando.value = true;
  try {
    await store.dispatch('liberarCongelamento', {
      conversationId: props.conversationId,
      contactId: props.contactId,
      motivo: motivo.value.trim(),
    });
    useAlert(t('CONVERSATION.HEADER.CONGELADO.LIBERADO'));
    dialogRef.value?.close();
  } catch (error) {
    useAlert(t('CONVERSATION.HEADER.CONGELADO.ERRO'));
  } finally {
    enviando.value = false;
  }
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    width="md"
    icone="i-ph-shield-warning"
    :title="t('CONVERSATION.HEADER.CONGELADO.TITULO')"
    :description="t('CONVERSATION.HEADER.CONGELADO.DESCRICAO')"
    :confirm-button-label="t('CONVERSATION.HEADER.CONGELADO.CONFIRMAR')"
    :disable-confirm-button="!podeConfirmar"
    :is-loading="enviando"
    @confirm="confirmar"
  >
    <div class="mt-2">
      <label for="motivo-da-liberacao" class="advup-rotulo">
        {{ t('CONVERSATION.HEADER.CONGELADO.ROTULO_MOTIVO') }}
      </label>
      <textarea
        id="motivo-da-liberacao"
        v-model="motivo"
        :placeholder="t('CONVERSATION.HEADER.CONGELADO.EXEMPLO_MOTIVO')"
        rows="4"
        class="advup-campo advup-campo--area"
      />
    </div>
  </Dialog>
</template>
